'use strict';

module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// ./~/rc-switch/lib/index.js
// module id = 578
// module chunks = 35783957827783 65974612472484